import React, { useState } from 'react'
import { Button, Typography } from '@mui/material'
import makeStyles from '@mui/styles/makeStyles'
import { useHistory } from 'react-router-dom'

import { trackStartCheckInCall } from 'src/mixpanel/api'
import { PatientHistoryType } from 'src/graphql.generated'
import VideoCallBookingInformation from '../VideoCallBookingInformation'
import { InProgramVideoCallFragment } from '../videoCallBookingHeaderQueries.generated'
import { useCallNotesHandler } from '../CallNotesHandler'
import JoinCallButton from '../JoinCallButton'
import ModifyInProgramCallModal from './ModifyInProgramCallModal/ModifyInProgramCallModal'

import useIsPrimaryCoachOfPatient from '../useIsPrimaryCoachOfPatient'

type Props = { videoCall: InProgramVideoCallFragment; uid: string }

const scrollToPatientHistory = (entryID?: string | null) => {
  setTimeout(() => {
    const selector = entryID ? `#patient-history-${entryID}` : '[data-participant-history]'
    const element = document.querySelector(selector)
    if (element) {
      element.scrollIntoView({ behavior: 'smooth', block: 'start' })
    }
  }, 100)
}

const InProgramVideoCallBookingInformation = ({ videoCall, uid }: Props) => {
  const isPrimaryCoachOfPatient = useIsPrimaryCoachOfPatient(uid)
  const styles = useStyles()
  const history = useHistory()
  const openCallNotes = useCallNotesHandler()

  const [modifyModalOpen, setModifyModalOpen] = useState(false)

  const { startTime, checkInCallPatientHistoryEntryID } = videoCall
  const now = new Date()
  const isUpcomingCall = startTime > now

  const handleNotesClick = () => {
    if (openCallNotes) {
      openCallNotes(videoCall.id, checkInCallPatientHistoryEntryID)
      return
    }

    if (checkInCallPatientHistoryEntryID) {
      history.push(`/participant/${uid}/records`)
      scrollToPatientHistory(checkInCallPatientHistoryEntryID)
      return
    }

    history.push(`/participant/${uid}/records?formType=${PatientHistoryType.CheckInCall}&callID=${videoCall.id}`)
    scrollToPatientHistory()
  }

  return (
    <>
      <ModifyInProgramCallModal
        videoCall={videoCall}
        uid={uid}
        onClose={() => setModifyModalOpen(false)}
        open={modifyModalOpen}
      />
      <VideoCallBookingInformation
        videoCall={videoCall}
        callActions={
          <>
            {isPrimaryCoachOfPatient && (
              <Button color="primary" variant="outlined" className={styles.notesButton} onClick={handleNotesClick}>
                <Typography variant="button">Notes</Typography>
              </Button>
            )}
            {isUpcomingCall && (
              <Button
                variant="outlined"
                color="primary"
                className={styles.modifyButton}
                onClick={() => setModifyModalOpen(true)}
              >
                Modify
              </Button>
            )}
            <JoinCallButton videoCall={videoCall} mixpanelTrackingEvent={trackStartCheckInCall} />
          </>
        }
      />
    </>
  )
}

const useStyles = makeStyles((theme) => ({
  modifyButton: {
    backgroundColor: '#fff',
    marginRight: theme.spacing(1),
  },
  notesButton: {
    backgroundColor: '#FFF',
    marginRight: theme.spacing(1),
  },
}))

export default InProgramVideoCallBookingInformation
